import { render } from "./AppHeader.vue?vue&type=template&id=48d66a78&scoped=true&ts=true&lang=pug"
import script from "./AppHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppHeader.vue?vue&type=script&lang=ts&setup=true"

import "./AppHeader.vue?vue&type=style&index=0&id=48d66a78&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d66a78"]])

export default __exports__